<section fxLayout="column" fxLayoutAlign="start center">
  <app-banner [text]="bannerMessage"></app-banner>
  <div id="entry-point-spinner" class="spinner-container" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</section>
